<template>
  <div class="reportGrid">
    <el-card class='page' body-style="overflow: scroll">
      <h5 style="marginTop: 0px">Search</h5>
      <el-input placeholder="Search Content" @input="filter" v-model="search"></el-input>
      <div class="checkContainer">
        <h5>Contracts</h5>
        <el-switch v-model="contractsOn"/>
      </div>
      <el-checkbox-group v-if="contractsOn" @change="filter" v-model="contractFilters">
        <el-checkbox class="checkbox" v-for="contract in contracts" :label="contract.name" :key="contract.id"></el-checkbox>
      </el-checkbox-group>
      <div class="checkContainer">
        <h5>Programs</h5>
        <el-switch v-model="programsOn"/>
      </div>
      <el-checkbox-group v-if="programsOn" @change="filter" v-model="programFilters">
        <el-checkbox class="checkbox" v-for="program in programs" :label="program.name" :key="program.id"></el-checkbox>
      </el-checkbox-group>
      <h5>Users</h5>
      <el-select  v-model="userSelect" @change="filter" multiple filterable placeholder="Select" style="width: 100%;">
        <el-option class="userSelect"
          v-for="user in users"
          :key="user.id"
          :label="user.name"
          :value="user.name">
        </el-option>
      </el-select>
      <h5>Managers</h5>
      <el-select  v-model="managerSelect" @change="filter" multiple filterable placeholder="Select" style="width: 100%;">
        <el-option class="userSelect"
          v-for="manager in managers"
          :key="manager.id"
          :label="manager.name"
          :value="manager.name">
        </el-option>
      </el-select>
      <h5>Dates</h5>
      <div class="dateContainer">
        <div style="width: 60px">from: </div>
        <el-date-picker format="MMM yy" @change="filter" type="month" placeholder="from" v-model="date1" style="width: 100%;"></el-date-picker>
      </div>
      <div class="dateContainer">
        <div style="width: 60px">to: </div>
        <el-date-picker format="MMM yy" @change="filter" type="month" placeholder="to" v-model="date2" style="width: 100%;"></el-date-picker>
      </div>
    </el-card>
    <el-card v-loading="loading" class="page" key="hello">
      <ReportTable :tableData="filteredData" @updateReports2="updateReports2"/>
    </el-card>
    <el-dialog
      id="userDialog"
      :visible.sync="dialogVisible"
      width="60%"
      v-bind:append-to-body='true'
      >
      <h2 slot="title" style="margin: 0px">
        {{activeReport.name}} : {{moment(activeReport.month).format('MMM YYYY')}}
      </h2>
      <ReportView :data="activeReport"/>
    </el-dialog>
  </div>
</template>

<script>
/* import firebase from 'firebase' */
/* import {database} from '../main' */
/* import firebase from 'firebase' */
import Moment from 'moment'
import { extendMoment } from 'moment-range';
import ReportTable from './ReportTable'
import ReportView from './ReportView'
import { getReportsMixin } from './getReportsMixin'
const moment = extendMoment(Moment);
export default {
  name: 'hello',
  mixins: [getReportsMixin],
  components: {
    ReportView,
    ReportTable
  },
  data () {
    return {
      moment,
      activeReport: {},
      dialogVisible: false,
      loading: false
    };
  },
  methods: {
    updateReports2 () {
      this.fetchData()
    },
    viewReport (data) {
      this.activeReport = data
      this.dialogVisible = true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dateContainer {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .userSelect {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .reportGrid {
    grid-column-gap: 10px;
    display: grid;
    grid-template-columns: 1fr 4fr;
  }
  .button {
    margin-bottom: 10px;
  }
  .checkbox {
    display: block;
    margin-left: 0px;
    margin-bottom: 10px;
  }
  .checkContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  #userDialog {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .page {
    height: calc(100vh - 120px);
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports.vue